import Message from "./message.component.js";

export default angular
    .module("oui.message", [])
    .component("ouiMessage", Message)
    .name;
